<div class="content-snackbar">
  <div class="text">
    {{ data.message }}
  </div>
  <mat-icon>{{ data.icon }}</mat-icon>
</div>
